import { mapState } from 'vuex';
import consolidatedClosureList from "../consolidated-closure-list/ConsolidatedClosureList.vue";
import returnedOrderList from "../returned-order-grid/ReturnedOrderList.vue";
import readDocumentList from "../read-document-grid/ReadDocumentList.vue";
import rescheduleList from "../reschedule/RescheduleList.vue";
import dayClosureList from "../day-closure-list/DayClosureList.vue";
import totalClosureDayGrid from "../total-closure-day/TotalClosureDayGrid.vue";
import { StorageService } from "../../services/StorageService";
import DayClosureService from "../../services/day-closure/DayClosureService";
import BarCodeScanner from "../../components/util/BarCodeScanner";
import i18n from "../../i18n/index";
import DayClosureBarCodeScanner from "../../components/util/DayClosureBarCodeScanner";

export default {
  components: {
    dayClosureList: consolidatedClosureList,
    returnedOrderList,
    readDocumentList,
    dayClosureListData: dayClosureList,
    totalClosureDayGrid,
    BarCodeScanner,
    rescheduleList,
    DayClosureBarCodeScanner
  },
  data: () => ({
    dialog: false,
    date: new Date().toISOString().substr(0, 10),
    showGrid: false,
    menu: false,
    summaryData: [],
    returnsData: [],
    missingDocumentsData: [],
    shippingFeeTotal: "",
    userData: {},
    totalItems: [],
    savingDayClosure: false,
    loadingSearch: false,
    dayClosureCompleted: false,
    prueba: '',
    prueba1: '',
    idOrder: [],
    checkStatusSticker: '',
    dialogReturned: false,
    dialogMissing2: false,
    barcodesReturned: [],
    barcodesMissing: [],
    documentCountReturned: 0,
    documentCountMissing: 0
  }),

  created() {
    this.userData = StorageService.getUserData();
  },

  props: {
    selectedDate: {
      type: String,
      default: () => ""
    }
  },

  computed: {
    ...mapState('auth', ['userInfo']),
  },

  methods: {
    initScanReturned() {
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 187) {
          e.preventDefault();
          return;
        }
      });
      this.dialogReturned = true;
      this.$barcodeScanner.init(this.onBarcodeScannedReturned);
    },
    async onBarcodeScannedReturned(barcode) {
      if (barcode === "Enter") {
        return;
      }

      const regex = /'/i;
      barcode = barcode.replace(regex, '-')

      if (!this.barcodesReturned.includes(barcode)) {
        this.handleReturnedDocument(barcode)
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("scan-component.barcode-scanned-already"),
        });
      }
    },

    emitBarcodesReturned() {
      this.$barcodeScanner.destroy();
      this.dialogReturned = false;
    },
    initScanMissing() {
      window.addEventListener("keydown", (e) => {
        if (e.keyCode === 187) {
          e.preventDefault();
          return;
        }
      });
      this.dialogMissing2 = true;
      this.$barcodeScanner.init(this.onBarcodeScannedMissing);
    },
    async onBarcodeScannedMissing(barcode) {
      if (barcode === "Enter") {
        return;
      }

      const regex = /'/i;
      barcode = barcode.replace(regex, '-')

      if (!this.barcodesMissing.includes(barcode)) {
        this.handleDeliveredDocument(barcode)
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("scan-component.barcode-scanned-already"),
        });
      }
    },

    emitBarcodesMissing() {
      this.$barcodeScanner.destroy();
      this.dialogMissing2 = false;
    },
    async getUserId() {
      let userId = await StorageService.getUserData().id;
      if (!userId || typeof userId === 'string') {
        if (this.userInfo) {
          userId = this.userInfo.id
        }
        userId = 0
      }
      return userId
    },

    async getProviderIds(orderDetails) {
      let providerIds = []
      orderDetails.map(orderDetail => {
        providerIds.push(orderDetail.providerId)
      })
      return providerIds;
    },

    generateReport() {
      DayClosureService.postGenerateReport(this.date).then(response => {
        const blobData = new Blob([response.data.code.join("\n")], {
          type: "text/plain"
        });
        const fileName = `generar_planilla_${this.selectedDate
          .split("-")
          .join("")}.xlsx`;
        const a = document.getElementById("exported-file");
        a.href = URL.createObjectURL(blobData);
        a.download = fileName;
        a.click();
      });
    },

    closeDayClosure() {
      this.dialog = false;
      this.showGrid = false;
      this.idOrder = [];
      this.barcodesReturned = []
      this.barcodesMissing = []
      this.documentCountReturned = 0
      this.documentCountMissing = 0
    },

    async getDayClosure() {
      this.getSummary();
      this.updateAllGrids();
    },

    async updateAllGrids() {
      this.getReturns();
      this.getMissingDocuments();
      this.getTotals();
      this.getShippingFeeTotal();
    },

    async getSummary() {
      try {
        this.loadingSearch = true;
        let userId = await this.getUserId();
        const res = await DayClosureService.getSummary(
          userId,
          this.date
        );
        if (res) {
          this.summaryData = res.data;
        }
        this.loadingSearch = false;

      } catch (error) {
        this.loadingSearch = false;
        this.showError(i18n.t("day-closure.error-consulting-summary"));
      }
    },

    async getReturns() {
      try {
        let userId = await this.getUserId();
        const res = await DayClosureService.getReturns(
          userId,
          this.date
        );
        if (res) {
          // this.idOrder = res.data[0].orderNumber
          this.returnsData = res.data;
        }
      } catch (error) { }
    },

    async getMissingDocuments() {
      try {
        let userId = await this.getUserId();
        const res = await DayClosureService.getMissingDocuments(
          userId,
          this.date
        );
        if (res) {
          this.missingDocumentsData = res.data;
          if (this.missingDocumentsData.length > 0) {
            this.dayClosureCompleted = false;
          }
        }
      } catch (error) { }
    },

    async getTotals() {
      try {
        let userId = await this.getUserId();
        const res = await DayClosureService.getTotals(
          userId,
          this.date
        );
        if (res) {
          this.totalItems = res.data;
        }
      } catch (error) { }
    },

    async getShippingFeeTotal() {
      try {
        let userId = await this.getUserId();
        const res = await DayClosureService.getShippingFeeTotal(
          userId,
          this.date
        );
        if (res && res.data) {
          const shippingFeeTotal = res.data.shippingFeeTotal;
          // eslint-disable-next-line no-unneeded-ternary
          this.shippingFeeTotal = shippingFeeTotal ? shippingFeeTotal : 0;
        }
      } catch (error) { }
    },

    async handleReturnedDocument(sitckerData) {
      this.checkStatusSticker = ''
      sitckerData = sitckerData.split("'").join("-");
      let userId = await this.getUserId();
      try {
        const res = await DayClosureService.registerReturn(
          userId,
          this.date,
          sitckerData
        );
        if (res.data.code === "ALREADY_RETURNED") {
          this.showError(i18n.t("day-closure.already-returned-document"));
          return;
        } else if (res.data.code === "INVALID_STICKER") {
          this.showError(i18n.t("day-closure.invalid-sticker-error"));
          return;
        } else {
          this.checkStatusSticker = `${sitckerData}*${true}`
          if (!this.idOrder.includes(res.data['idOrder'].id)) {
            this.idOrder.push(res.data['idOrder'].id)
          }
          this.barcodesReturned.unshift(sitckerData)
          this.documentCountReturned = this.barcodesReturned.length
          this.updateAllGrids();
        }
      } catch (error) {
        if (error && error.code) {
          if (error.code === "ALREADY_RETURNED") {
            this.showError(i18n.t("day-closure.already-returned-document"));
          } else if (error.code === "INVALID_STICKER") {
            this.showError(i18n.t("day-closure.invalid-sticker-error"));
          } else {
            this.showError(i18n.t("day-closure.error-registering-return"));
          }
        }
      }
    },
    async handleDeliveredDocument(barcode) {
      try {
        this.checkStatusSticker = ''
        let userId = await this.getUserId();
        const res = await DayClosureService.registerDelivered(
          userId,
          this.date,
          barcode
        );
        if (res.data.code === "INVALID_BARCODE" || res.data.code === "Invalid barcode.") {
          this.$notify({
            group: "app",
            type: "error",
            text: `${i18n.t("day-closure.invalid-barcode-error")} ó ${i18n.t('distribution.suborder-different-date')}`
          });
          return;
        } else if (res.data.code === 'INVALID_DATE') {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t('distribution.suborder-different-date')
          });
          return;
        } else {
          this.checkStatusSticker = `${barcode}*${true}`
          if (!this.idOrder.includes(res.data['idOrder'].id)) {
            this.idOrder.push(res.data['idOrder'].id)
          }
          this.barcodesMissing.unshift(barcode)
          this.documentCountMissing = this.barcodesMissing.length
          this.$notify({
            group: "app",
            type: "success",
            text: i18n.t("day-closure.success-registering-document")
          });
          this.updateAllGrids();
        }
      } catch (error) {
        if (error && error.code === "INVALID_BARCODE") {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("day-closure.invalid-barcode-error")
          });
        } else {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("day-closure.error-registering-delivered")
          });
        }
      }
    },
    async saveDayClosure() {
      try {
        this.savingDayClosure = true;
        let userId = await this.getUserId();
        const res = await DayClosureService.saveDayClosure(
          this.idOrder,
          userId,
          this.date
        );
        if (res) {
          this.$notify({
            group: "app",
            type: "success",
            text: i18n.t("day-closure.success-saving-day-closure")
          });
          this.showGrid = false;
          this.summaryData = [];
          this.returnsData = [];
          this.missingDocumentsData = [];
          this.shippingFeeTotal = "";
          this.userData = {};
          this.totalItems = [];
          this.idOrder = []
          this.barcodesReturned = []
          this.barcodesMissing = []
          this.documentCountReturned = 0
          this.documentCountMissing = 0
          this.$refs.dayClosureListData.getDayClosures();
        }
        this.savingDayClosure = false;
      } catch (error) {
        this.savingDayClosure = false;
        if (error && error.code === "NO_DAY_CLOSURE") {
          this.showError(i18n.t("day-closure.no-day-closure"));
        } else if (error && error.code === "NOT_ALL_DELIVERED") {
          this.showError(i18n.t("day-closure.pending-orders-for-delivery"));
        } else {
          this.showError(i18n.t("day-closure.error-saving-day-closure"));
        }
      }
    },

    showError(message) {
      this.$notify({
        group: "app",
        type: "error",
        text: message
      });
    },

    showSuccess(message) {
      this.$notify({
        group: "app",
        type: "success",
        text: message
      });
    },

    searchDayClosure(dayClosure) {
      this.showNewDayClosure();
      this.date = dayClosure.dayClosureDate
        ? dayClosure.dayClosureDate.split("T")[0]
        : new Date().toISOString().substr(0, 10);
      this.dayClosureCompleted = dayClosure.completed;
      this.getDayClosure();
    },

    showNewDayClosure() {
      this.showGrid = true;
      this.summaryData = [];
      this.returnsData = [];
      this.missingDocumentsData = [];
      this.shippingFeeTotal = "";
      this.userData = {};
      this.totalItems = [];
      this.idOrder = []
      this.barcodesReturned = []
      this.barcodesMissing = []
      this.documentCountReturned = 0
      this.documentCountMissing = 0
    },

    async cancelReturns() {
      if (this.returnsData.length === 0) {
        return;
      }

      let data = {
        date: this.date,
        orders: this.returnsData
      };

      await DayClosureService.cancelReturns(data)
        .then(response => {
          if (response.data.code === "Successfully!") {
            this.showSuccess("Pedido(s) devueltos correctamente.");
          }
        })
        .catch(err => {
          this.showError(err.code);
          return err;
        });
    }
  }
};
